module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/318.2a2e44de.png";